import copyTextToClipboard from 'react-utils/copyTextToClipboard';
import devLogger from 'react-utils/devLogger';
const copyWithClipboardItem = async ({
  text,
  html
}) => {
  var _navigator$clipboard;
  if (typeof navigator === 'undefined' || typeof ClipboardItem === 'undefined' || !((_navigator$clipboard = navigator.clipboard) !== null && _navigator$clipboard !== void 0 && _navigator$clipboard.write)) {
    return false;
  }
  try {
    // eslint-disable-next-line compat/compat
    const item = new ClipboardItem({
      'text/html': new Blob([html], {
        type: 'text/html'
      }),
      'text/plain': new Blob([text], {
        type: 'text/plain'
      })
    });
    // eslint-disable-next-line compat/compat
    await navigator.clipboard.write([item]);
    return true;
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      devLogger.warn({
        key: 'copyRichTextToClipboard Clipboard API failed',
        message: 'copyRichTextToClipboard: Clipboard API failed, falling back to the copy event method. ' + 'This can happen in iframes or when clipboard permissions are denied.'
      });
    }
    return false;
  }
};
const copyWithCopyEvent = ({
  text,
  html
}) => {
  const onCopy = e => {
    if (!e.clipboardData) return;
    e.clipboardData.setData('text/html', html);
    e.clipboardData.setData('text/plain', text);
    e.preventDefault();
  };
  document.addEventListener('copy', onCopy);
  try {
    // execCommand returns false when the copy is blocked (e.g. no user
    // gesture), in which case the listener never ran or its data was discarded.
    return document.execCommand('copy');
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      devLogger.warn({
        key: 'copyRichTextToClipboard fallback copy failed',
        message: 'copyRichTextToClipboard: Both Clipboard API and copy event fallback failed to copy rich text.'
      });
    }
    return false;
  } finally {
    document.removeEventListener('copy', onCopy);
  }
};

/**
 * Copies `html` and `text` to the clipboard as separate `text/html` and
 * `text/plain` entries, so rich targets (Sheets, Docs, Gmail) paste `html`
 * while plain-text targets paste `text`. Falls back to plain text only if both
 * rich strategies fail. Must be called synchronously within a user gesture.
 */
export default async function copyRichTextToClipboard({
  text,
  html
}) {
  let success = await copyWithClipboardItem({
    text,
    html
  });
  if (!success) {
    success = copyWithCopyEvent({
      text,
      html
    });
  }
  if (!success) {
    success = await copyTextToClipboard(text);
  }
  return success;
}